import { EVENT_MEMBER_TYPE, EVENT_STAGE_FORMAT, PARTICIPANTS_PER_TEAM } from '@/modules/Events/constants';
import BaseModel from './base';
import { localeFormatDefault } from '@/plugins/date-print';

export default class NominationOptions extends BaseModel {
  constructor(options, url) {
    super(options, url);

    this.nomination_id = options.nomination_id;
    this.event_id = options.event_id;

    this.is_with_moderation = options.is_with_moderation;

    this.block_request_groups_ids = options.block_request_groups_ids || [];
    this.max_participants = options.max_participants || null;

    this.start_accepting_at = localeFormatDefault(options.start_accepting_at);
    this.end_accepting_at = localeFormatDefault(options.end_accepting_at);

    // При подаче заявки можно не указывать конкретную категорию
    this.block_request_without_group = options.block_request_without_group;

    this.can_create_team = options.can_create_team;
    this.can_upload_document = options.can_upload_document;
    this.can_upload_image = options.can_upload_image;
    this.can_upload_link = options.can_upload_link;

    this.event_member_type = options.event_member_type ?? EVENT_MEMBER_TYPE.single;

    this.max_participants_per_team = options.max_participants_per_team ?? PARTICIPANTS_PER_TEAM.max;
    this.min_participants_per_team = options.min_participants_per_team ?? PARTICIPANTS_PER_TEAM.min;
    this.can_change_team_members = options.can_change_team_members ?? false;

    this.format = options.format ?? EVENT_STAGE_FORMAT.fulltime;
  }

  get isTeam() {
    return this.event_member_type === EVENT_MEMBER_TYPE.team;
  }
}
